import { LinkProps } from '@tanstack/react-router';

import { Button, ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { FileRouteTypes } from '@/routeTree.gen';

export interface TableEmptyStateProps {
  heading?: string;
  subHeading?: string;
  actionText?: string;
  actionIcon?: React.ReactNode;
  actionTo?: FileRouteTypes['to'] | '.';
  actionParams?: LinkProps['params'];
  actionSearch?: LinkProps['search'];
  actionOnClick?: () => void;
  actionButtonVariant?: ButtonProps['variant'];
  className?: string;
}

export function TableEmptyState({
  actionText,
  actionTo,
  actionIcon,
  actionParams,
  actionSearch,
  actionOnClick,
  actionButtonVariant = 'driverBrandBlue',
  heading,
  subHeading,
  className,
}: TableEmptyStateProps) {
  return (
    <div className={cn('py-10 text-center', className)}>
      {heading && <div className="text-foreground/90 mb-1 text-base font-medium">{heading}</div>}
      {subHeading && <div className="text-muted-foreground mx-auto mb-4 text-sm">{subHeading}</div>}
      {actionText ? (
        <Button
          to={actionTo}
          params={actionParams}
          search={actionSearch}
          variant={actionButtonVariant}
          size="xs"
          onClick={actionOnClick}
        >
          {actionText}
          {actionIcon}
        </Button>
      ) : null}
    </div>
  );
}

export default TableEmptyState;
